import nprogress, { NProgressOptions } from "nprogress";

interface NProgressSettings extends NProgressOptions {
  delay: number;
}

export interface INProgress {
  configure: (settings: Partial<NProgressSettings>) => void;
  doStart: () => void;
  start: { (): void; (): void };
  doDone: () => void;
  done: { (): void; (): void };
  clearDelay: () => void;

  startDelay: ReturnType<typeof setTimeout> | undefined;
  settings: NProgressSettings;
}

const NProgress: INProgress = {
  ...(nprogress as unknown as INProgress),
  // eslint-disable-next-line @typescript-eslint/unbound-method
  doStart: nprogress.start,
  // eslint-disable-next-line @typescript-eslint/unbound-method
  doDone: nprogress.done,
  start: function () {
    this.clearDelay();
    this.startDelay = setTimeout(function () {
      NProgress.doStart();
    }, this.settings.delay);
  },
  clearDelay: function () {
    if (this.startDelay) {
      clearTimeout(this.startDelay);
      this.startDelay = undefined;
    }
  },
  done: function () {
    this.clearDelay();
    this.doDone();
  },
};

NProgress.configure({
  showSpinner: false,
  delay: 250,

  barSelector: "#nprogress-bar",
  template:
    // by default, nprogress uses the "bar" aria role, which isn't semantically correct
    // The `status` role is used to indicate that an element will receive updated content
    // that is important for the user to be aware of, but not so critical that it needs
    // to interrupt the user's current activity. It's commonly used for status messages
    // that provide feedback to the user, such as "Form submitted successfully" or "Data saved."
    '<div id="nprogress-bar" class="bar" role="status"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>',
});

export default NProgress;
